import { render, staticRenderFns } from "./Alert_data.vue?vue&type=template&id=c48ffd06&"
import script from "./Alert_data.vue?vue&type=script&lang=js&"
export * from "./Alert_data.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports